<script setup lang="ts">
import BaseTooltip from "@/components/ui/BaseTooltip/BaseTooltip.vue";

// Tippy derives text from the DOM to handle slotted content
const fullText = (el: Element) => el.textContent?.trim() ?? "";
</script>

<template>
  <div class="menu-list-subheader">
    <BaseTooltip :content="fullText" only-show-on-overflow show-when-clipped class="text">
      <slot />
    </BaseTooltip>
  </div>
</template>

<style lang="scss" scoped>
@use "@/styles/variables/colors";
@use "@/styles/mixins/typography";
@use "@/styles/mixins/utils";

.menu-list-subheader {
  @include typography.small("bold");

  padding: 6px 12px;

  .text {
    @include utils.ellipsis;

    display: block;
  }
}

.menu-list-items > .menu-list-subheader:first-child {
  padding-top: 10px;
}
</style>
